import React, { useState, useEffect, useContext } from "react";
import { TranslatorContext } from "../../../context/Translator";
import { Link } from "react-router-dom";
import { Row, Col, Table } from "react-bootstrap";
import PageLayout from "../../../layouts/PageLayout";
import axios from "axios";

export default function LabTestTemplatePage() {
    const { t } = useContext(TranslatorContext);
    const AuthToken = localStorage.getItem("authToken");

    const [templates, setTemplates] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchTemplates = async () => {
            try {
                axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;

                const res = await axios.get(
                    process.env.REACT_APP_API_URL + "/lab-test-templates"
                );

                setTemplates(res.data || []);
            } catch (err) {
                console.error("Fetch Error:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchTemplates();
    }, [AuthToken]);

    const handleDelete = async (id) => {
        if (window.confirm(t("Are you sure you want to delete this template?"))) {
            try {
                await axios.delete(
                    process.env.REACT_APP_API_URL + `/lab-test-templates/${id}`,
                    {
                        headers: {
                            Authorization: `Bearer ${AuthToken}`
                        }
                    }
                );
                setTemplates(prev => prev.filter(template => template.id !== id));
            } catch (err) {
                console.error("Delete Error:", err);
            }
        }
    };

    if (loading) return <PageLayout><p>{t("loading")}...</p></PageLayout>;

    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className="mc-breadcrumb">
                            <h3 className="mc-breadcrumb-title">{t('Lab Test Templates')}</h3>
                            <ul className="mc-breadcrumb-list">
                                <li className="mc-breadcrumb-item">
                                    <Link to="#" className="mc-breadcrumb-link">{t('home')}</Link>
                                </li>
                                <li className="mc-breadcrumb-item">
                                    <Link to="#" className="mc-breadcrumb-link">{t('Lab Test')}</Link>
                                </li>
                                <li className="mc-breadcrumb-item">{t('Templates')}</li>
                            </ul>
                        </div>
                    </div>
                </Col>

                <Col xl={12}>
                    <div className="mc-card">
                        {/* Add New Button - Similar to PaymentMethodsIndex but using Link */}
                        <div className="mc-card-header d-flex justify-content-between align-items-center p-3">
                            <h5 className="mc-card-title mb-0">{t('Lab Test Templates List')}</h5>
                            <Link to="/lab-test-templates/create" className="btn btn-primary d-flex align-items-center">
                                <i className="material-icons">add</i>
                                {t('Create Template')}
                            </Link>
                        </div>

                        <Row>
                            <Col xl={12}>
                                <div className="mc-card">
                                    <div className="table-responsive-wrapper">
                                        <Table responsive className="table mb-0">
                                            <thead>
                                                <tr>
                                                    <th>
                                                        <div className="mc-table-check">
                                                            <p>#</p>
                                                        </div>
                                                    </th>
                                                    <th>{t('Template Name')}</th>
                                                    <th>{t('Lab Test')}</th>
                                                    <th>{t('Pet Breed')}</th>
                                                    <th>{t('actions')}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {templates.length > 0 ? (
                                                    templates.map((item, index) => (
                                                        <tr key={item.id}>
                                                            <td>
                                                                <div className="mc-table-check">
                                                                    <p>{index + 1}</p>
                                                                </div>
                                                            </td>
                                                            <td>{item.name}</td>
                                                            <td>{item.lab_test.name}</td>
                                                            <td>{item.pet_breed?.name}</td>
                                                            <td>
                                                                <div className="mc-table-action">
                                                                    <Link
                                                                        to={`/lab-test-templates/edit/${item.id}`}
                                                                        className="material-icons edit"
                                                                        title={t('Edit')}
                                                                    >
                                                                        edit
                                                                    </Link>
                                                                    <button
                                                                        type="button"
                                                                        className="material-icons delete"
                                                                        onClick={() => handleDelete(item.id)}
                                                                        title={t('Delete')}
                                                                    >
                                                                        delete
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="5" className="text-center">
                                                            {t('No Templates Found')}
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
        </PageLayout>
    );
}